import React, { useState } from 'react';
import styled from 'styled-components';
import AdminSectionTitle from '../../../components/admin/AdminSectionTitle';
import EmailNotificationSetting from './EmailNotificationSetting';
import KakaoNotificationSetting from './KakaoNotificationSetting';

const TAB_EMAIL = 'email';
const TAB_KAKAO = 'kakao';

const NotificationSetting = () => {
	const [activeTab, setActiveTab] = useState(TAB_EMAIL);

	return (
		<Content>
			<AdminSectionTitle title="알림 관리" />
			<TabRow>
				<Tab
					type="button"
					$active={activeTab === TAB_EMAIL}
					onClick={() => setActiveTab(TAB_EMAIL)}
				>
					메일 전송
				</Tab>
				<Tab
					type="button"
					$active={activeTab === TAB_KAKAO}
					onClick={() => setActiveTab(TAB_KAKAO)}
				>
					카카오톡 전송
				</Tab>
			</TabRow>
			<TabContent>
				{activeTab === TAB_EMAIL && <EmailNotificationSetting />}
				{activeTab === TAB_KAKAO && <KakaoNotificationSetting />}
			</TabContent>
		</Content>
	);
};

const Content = styled.div`
	width: 100%;
	max-width: 1240px;
	padding: 40px;
	background-color: white;

	@media only screen and (max-width: 1023.98px) {
		padding: 40px 20px;
	}

	@media only screen and (max-width: 479.98px) {
		padding: 20px 10px;
	}
`;

const TabRow = styled.div`
	margin-top: 20px;
	display: flex;
	align-items: stretch;
	width: 100%;
`;

const Tab = styled.button`
	flex: 1;
	width: 50%;
	padding: 10px 20px;
	border: 1px solid #dddddd;
	background-color: ${(p) => (p.$active ? '#ffffff' : '#f7f7f7')};
	border-bottom: ${(p) => (p.$active ? '2px solid transparent' : '1px solid #dddddd')};
	margin-bottom: ${(p) => (p.$active ? '-1px' : '0')};
	cursor: pointer;
	font-family: 'Pretendard';
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${(p) => (p.$active ? '#0e498f' : '#666666')};

	&:first-of-type {
		border-radius: 5px 0 0 0;
		border-right: none;
	}
	&:last-of-type {
		border-radius: 0 5px 0 0;
		border-left: 1px solid #dddddd;
	}
	&:hover {
		color: #0e498f;
	}
`;

const TabContent = styled.div`
	margin-top: 0;
	border: 1px solid #dddddd;
	border-top: none;
	padding: 40px 30px;
`;

export default NotificationSetting;
